var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),(_vm.$route.name == 'pageCategory')?[_c('v-container',{staticClass:"container--narrow"},[(_vm.items.length)?_c('FilterableList',{attrs:{"items":_vm.items},on:{"itemClick":_vm.itemClick}}):_c('v-alert',{staticClass:"ma-3",attrs:{"type":"info"}},[_vm._v(" Ei sivuja ")])],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }